import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountApi } from '../../../../api/base';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { mustMatchValidator } from '../../../../functions/validators/must-match';
import { LoginService } from '../../../../service/login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-page-login',
    templateUrl: './page-login.component.html',
    styleUrls: ['./page-login.component.scss'],
})
export class PageLoginComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject<void>();

    loginForm: FormGroup;
    loginInProgress = false;

    registerForm: FormGroup;
    registerInProgress = false;
    otp:number;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private account: AccountApi,
        private service : LoginService,
        private toastr: ToastrService,

    ) { }
    showForm:boolean = false;
    value:any;
    showError:any;
    ngOnInit(): void {
        if(!this.showForm){
            this.value = "Send OTP"
        }
        this.loginForm = this.fb.group({
            phone: ['', [Validators.required]],
            otp: ['']
            // remember: [false],
        });


        this.registerForm = this.fb.group({
            email: ['user@example.com', [Validators.required, Validators.email]],
            password: ['123456', [Validators.required]],
            confirmPassword: ['123456', [Validators.required]],
        }, {validators: [mustMatchValidator('password', 'confirmPassword')]});
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    resendOTP(){
        this.loginInProgress = true;
        let data = {
            "phone" : this.loginForm.value.phone
        }
            this.service.getOTP(data).subscribe((res : any) => {
                if(res.status){
                    console.log(res);

                    this.loginInProgress = false;

                }
            }, (err:any) =>{
                console.warn(err)
            }

            );
    }

    login(data): void {
        if(this.showForm){
            this.loginInProgress = true;


            if(this.loginForm.value.otp){
                let newdata = {
                    "phone" : this.loginForm.value.phone,
                    "otp" : this.loginForm.value.otp
                }
                console.log(newdata)
                this.service.verifyOTP(newdata).subscribe((res : any) => {
                    console.log(res)
                    if(res.status){
                    localStorage.setItem('user', JSON.stringify(res));
                    localStorage.setItem('islogged', "true");
                    localStorage.setItem('isLogged', "true");


                    this.loginInProgress = false;
                    this.toastr.success("Login Succesfully!!", "Success" , {timeOut: 3000});

                    // this.router.navigateByUrl('/account/')
                    window.location.reload();
                    }else{
                    this.loginInProgress = false;

                    this.toastr.warning("Invalid OTP.", "warning" , {timeOut: 3000});

                    }



                }, (err : any) => {
                    console.warn(err)
                })
            }else{
                console.log("yse")
                this.loginInProgress = false;
                this.toastr.error("OTP is required !!!", "Validation Error !!!" !!! , {timeOut: 3000});

                this.showError = true

            }


        }else{
            console.log(data);
            this.loginForm.markAllAsTouched();
            if (this.loginInProgress || this.loginForm.invalid) {
                return;
            }

            this.loginInProgress = true;

            this.service.getOTP(data).subscribe((res : any) => {
                if(res.status){
                    console.log(res);
                    this.showForm = true;
                    this.value = "Verify OTP"
                    this.toastr.success(
                        "OTP Sended Succesfully !!!", data.phone, {timeOut: 5000});

                    this.loginInProgress = false;

                }
            }, (err:any) =>{
                console.warn(err)
            }

            );
        }

    }

    register(): void {
        this.registerForm.markAllAsTouched();

        if (this.registerInProgress || this.registerForm.invalid) {
            return;
        }

        this.registerInProgress = true;

        this.account.signUp(
            this.registerForm.value.email,
            this.registerForm.value.password,
        ).pipe(
            finalize(() => this.registerInProgress = false),
            takeUntil(this.destroy$),
        ).subscribe(
            () => this.router.navigateByUrl('/account/dashboard'),
            error => {
                if (error instanceof HttpErrorResponse) {
                    this.registerForm.setErrors({
                        server: `ERROR_API_${error.error.message}`,
                    });
                } else {
                    alert(error);
                }
            },
        );
    }
}
